module.exports = __webpack_public_path__ + "static/media/leadership-image3.8d0427d7.jpeg";